function initInterstitials() {

  const entryModal = document.getElementById('interstitial-modal');
  const sizeGuideModal = document.getElementById('size-guide-modal');


  /*
   * ---------------------------------------------------------
   * Shared modal helpers
   * ---------------------------------------------------------
   */

  function isModalVisible(modal) {
    return modal && !modal.classList.contains('hidden');
  }

  function anyModalVisible() {
    return (
      isModalVisible(entryModal) ||
      isModalVisible(sizeGuideModal)
    );
  }

  function lockScroll() {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  function unlockScroll() {
    if (anyModalVisible()) return;

    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function openModal(modal) {
    if (!modal) return;

    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');

    lockScroll();
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');

    unlockScroll();
  }


  /*
   * ---------------------------------------------------------
   * Existing Entry Interstitial
   * ---------------------------------------------------------
   */

  if (entryModal) {

    const enterBtn =
      document.getElementById('enter-site');

    const closeBtn =
      document.getElementById('close-modal');

    const displayOn =
      entryModal.dataset.displayOn || 'all';

    const delay =
      (parseInt(entryModal.dataset.delay, 10) || 0) * 1000;

    const frequency =
      entryModal.dataset.frequency || 'always';

    const isHome =
      window.location.pathname === '/' ||
      window.location.pathname === '/index';

    const isMobile =
      window.innerWidth <= 600;

    const hasShown =
      localStorage.getItem('interstitialShown');

    const displayConditionMet =
      !(
        (displayOn === 'home' && !isHome) ||
        (displayOn === 'mobile' && !isMobile) ||
        (displayOn === 'desktop' && isMobile)
      );

    const frequencyConditionMet =
      !(frequency === 'once' && hasShown);


    if (
      displayConditionMet &&
      frequencyConditionMet
    ) {

      setTimeout(() => {
        openModal(entryModal);
      }, delay);


      [enterBtn, closeBtn].forEach((button) => {

        if (!button) return;

        button.addEventListener('click', () => {

          closeModal(entryModal);

          localStorage.setItem(
            'interstitialShown',
            'true'
          );

        });

      });


      entryModal.addEventListener('click', (event) => {

        if (event.target === entryModal) {

          closeModal(entryModal);

          localStorage.setItem(
            'interstitialShown',
            'true'
          );

        }

      });

    }

  }


  /*
   * ---------------------------------------------------------
   * Size Guide
   * ---------------------------------------------------------
   *
   * Event delegation allows this to work even when
   * Shopify dynamically re-renders the product form.
   */

  document.addEventListener('click', (event) => {

    const trigger =
      event.target.closest(
        '[data-interstitial-open="size-guide"]'
      );

    if (!trigger) return;

    event.preventDefault();

    if (!sizeGuideModal) return;

    openModal(sizeGuideModal);

  });


  /*
   * ---------------------------------------------------------
   * Size Guide close button
   * ---------------------------------------------------------
   */

  if (sizeGuideModal) {

    sizeGuideModal.addEventListener(
      'click',
      (event) => {

        const closeButton =
          event.target.closest(
            '[data-interstitial-close="size-guide"]'
          );

        if (closeButton) {

          closeModal(sizeGuideModal);

          return;

        }


        /*
         * Clicking the dark backdrop closes the modal.
         */

        if (
          event.target === sizeGuideModal ||
          event.target.classList.contains(
            'size-guide__overlay'
          )
        ) {

          closeModal(sizeGuideModal);

        }

      }
    );

  }


  /*
   * ---------------------------------------------------------
   * Escape Key
   * ---------------------------------------------------------
   */

  document.addEventListener('keydown', (event) => {

    if (event.key !== 'Escape') return;


    if (isModalVisible(sizeGuideModal)) {

      closeModal(sizeGuideModal);

      return;

    }


    if (isModalVisible(entryModal)) {

      closeModal(entryModal);

      localStorage.setItem(
        'interstitialShown',
        'true'
      );

    }

  });

}


/*
 * ---------------------------------------------------------
 * Initialize immediately if the DOM is already ready.
 * Otherwise wait for DOMContentLoaded.
 * ---------------------------------------------------------
 */

if (document.readyState === 'loading') {

  document.addEventListener(
    'DOMContentLoaded',
    initInterstitials
  );

} else {

  initInterstitials();

}